export const DEFAULT_LOCALE = 'ja';
